import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://localhost:5000', // URL de votre backend
  baseURL: 'https://kali.medtinz.com', // URL de votre backend en production
  // baseURL: 'https://front.kabaflow.com/', // URL test environment de votre backend
  // baseURL: 'https://medtinz-backend.onrender.com', // URL de votre backend
  headers: {
    'Content-Type': 'application/json',
  },
});

// Ajouter un intercepteur pour gérer le token d'authentification
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Ajouter un intercepteur de réponse pour gérer les erreurs 401
api.interceptors.response.use(
  (response) => response, // Renvoie la réponse si tout va bien
  (error) => {
    if (error.response && error.response.status === 419) {
      // Liste des chemins qui ne nécessitent pas d'authentification
      const publicPaths = ['/landingmed', '/clientlogin', '/', '/clientAdmin', '/clientsignup'];

      // Vérifie si l'utilisateur n'est pas déjà sur une page publique
      if (!publicPaths.includes(window.location.pathname)) {
        // Effacer le token expiré ou invalide
        localStorage.removeItem('access_token');

        // Rediriger vers la page de connexion
        window.location.href = '/clientlogin';

        // Afficher un message d'alerte
        alert('Votre session a expiré. Veuillez vous reconnecter.');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
